export const validateDateInput = ({ minDate, maxDate, formattedDate, excludeDates, startDateErrorMessage, endDateErrorMessage, excludeDatesErrorMessage }) => {
    const typedDate = new Date(formattedDate);
    const isDateRange = minDate !== maxDate;
    const isExcluded = excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some((date) => new Date(date.toDateString()).getTime() === typedDate.getTime());
    if (isDateRange && typedDate < minDate) {
        return startDateErrorMessage;
    }
    if (isDateRange && typedDate > maxDate) {
        return endDateErrorMessage;
    }
    if (isExcluded) {
        return excludeDatesErrorMessage;
    }
    return '';
};
export const validDateFormat = (testDate) => {
    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    return dateRegex.test(testDate);
};
